var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"help",attrs:{"href":"https://help-atelu.comnico.jp/","target":"_blank"},on:{"click":_setup.handleLinkClick}},[_c('i',{staticClass:"mdi mdi-help-circle"}),_vm._v("\n  ヘルプ\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }